import React, { useState, useEffect, useContext } from "react";
import { TimePicker, Select } from "antd";
import moment from "moment";
import "./ahp-time-picker.css";
import { AppContext } from "../../context";
import { FIELD_WIDTH } from "../../config/layoutConfig";

const format = "HH:mm";

const disabledHours = (hour) => {
  console.log("hour :>> ", hour);
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 15, 16, 17, 18, 22, 23];
};

const { Option } = Select;

const AHPTimePicker = ({
  availableTime = [],
  preferredTime,
  filterValues,
  setFilterValues,
  placeholder,
  timeValue,
  disabled,
  type,
  field,
  value,
  setValueFunc,
}) => {
  const [time, setTime] = useState(timeValue);
  const [availableTimeOptions, setAvailableTimeOptions] = useState(null);
  const info = useContext(AppContext);

  useEffect(() => {
    let availableTimeOptions = [];
    if (availableTime)
      for (const time of availableTime) {
        availableTimeOptions.push({
          label: time,
          value: time,
        });
      }
    setAvailableTimeOptions(availableTimeOptions);

    // setTime(
    //   preferredTime || availableTime[Math.floor(availableTime.length / 2)]
    // );
  }, [availableTime]);

  const handleSelectTime = (time) => {
    setTime(time);
    if (type === "guide") {
      info.setGuide({ ...info.guide, time: time });
      return;
    }
    if (type === "restaurant") {
      info.setRestaurant({
        ...info.restaurant,
        time: time,
      });
      return;
    }
    info.setService(type, info[type], field, time);
    if (setValueFunc) setValueFunc(time);
    //
    // if (setFilterValues) setFilterValues({ ...filterValues, time: time });
  };

  const getTimeValue = (type) => {
    return info[type].time;
  };

  return (
    <Select
      options={availableTimeOptions}
      placeholder={placeholder}
      style={{ width: FIELD_WIDTH / 3 }}
      value={getTimeValue(type)}
      onChange={(value) => handleSelectTime(value, field)}
      disabled={disabled}
      bordered={false}
      allowClear
    />
  );
};

export default AHPTimePicker;
